var r=Object.defineProperty;var i=Object.getOwnPropertyDescriptor;var s=Object.getOwnPropertyNames;var l=Object.prototype.hasOwnProperty;var d=(t,e)=>{for(var o in e)r(t,o,{get:e[o],enumerable:!0})},c=(t,e,o,a)=>{if(e&&typeof e=="object"||typeof e=="function")for(let n of s(e))!l.call(t,n)&&n!==o&&r(t,n,{get:()=>e[n],enumerable:!(a=i(e,n))||a.enumerable});return t};var g=t=>c(r({},"__esModule",{value:!0}),t);var u={};d(u,{getEditorHTML:()=>p});module.exports=g(u);const p=(t="#ffffff",e="\u8BF7\u8F93\u5165\u5185\u5BB9...")=>`
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
  <meta name="format-detection" content="telephone=no, date=no, email=no, address=no">
  <style>
    :root {
      --text-primary: #333;
      --text-placeholder: #999;
      --bg-surface: #fff;
      --bg-hover: #f5f5f5;
      --bg-pressed: #e8e8e8;
      --stroke-secondary: rgba(0,0,0,0.06);
      --shadow-popup: 0 8px 24px rgba(0,0,0,0.12);
      --scrollbar-thumb: rgba(0,0,0,0.15);
      --scrollbar-thumb-hover: rgba(0,0,0,0.25);
      --caret-color: #1890ff;
      --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    html, body {
      height: 100%;
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
      overflow: hidden;
      overflow-x: hidden;
      position: fixed;
      width: 100%;
      max-width: 100%;
      top: 0;
      left: 0;
      touch-action: none;
      overscroll-behavior: none;
      -webkit-overflow-scrolling: auto;
    }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      background-color: ${t};
      padding: 12px 12px 0 12px;
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      overflow-x: hidden;
    }

    #editor {
      flex: 1;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      min-height: 100px;
      outline: none;
      font-size: 12px;
      line-height: 1.6;
      color: var(--text-primary);
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-all;
      white-space: pre-line;
      overflow-x: hidden;
      overflow-y: auto;
      padding-bottom: 28px;
      padding-right: 8px;
      /* \u786E\u4FDD\u6EDA\u52A8\u5230\u5E95\u90E8\u65F6\u6700\u540E\u4E00\u884C\u6587\u5B57\u5B8C\u6574\u53EF\u89C1\uFF0C\u4E0D\u4F1A\u88AB\u5BB9\u5668\u88C1\u6389\u4E00\u534A */
      scroll-padding-bottom: 24px;
      caret-color: var(--caret-color);
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y;
      overscroll-behavior: contain;
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
      transition: scrollbar-color var(--transition-fast);
    }
    #editor:hover { scrollbar-color: var(--scrollbar-thumb) transparent; }
    #editor::-webkit-scrollbar { width: 4px; }
    #editor::-webkit-scrollbar-thumb { background: transparent; border-radius: 2px; }
    #editor::-webkit-scrollbar-track { background: transparent; }
    #editor:hover::-webkit-scrollbar-thumb { background: var(--scrollbar-thumb); }
    #editor:hover::-webkit-scrollbar-thumb:hover { background: var(--scrollbar-thumb-hover); }
    #editor * { max-width: 100%; }
    #editor:empty:before {
      content: attr(data-placeholder);
      color: var(--text-placeholder);
      pointer-events: none;
    }

    .tag {
      white-space: nowrap;
      -webkit-user-select: text;
      user-select: text;
      cursor: text;
      display: inline-block;
      max-width: calc(100% - 4px);
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: bottom;
      margin-left: 2px;
      margin-right: 2px;
    }
    .tag-at {
      color: #F01B3F;
    }
    .tag-hash {
      color: #821527;
    }

    #mention-popup {
      position: fixed;
      background: var(--bg-surface);
      border-radius: 12px;
      box-shadow: var(--shadow-popup);
      border: 0.5px solid var(--stroke-secondary);
      max-height: 60vh;
      min-width: 200px;
      max-width: 80vw;
      overflow-y: auto;
      overflow-x: hidden;
      display: none;
      z-index: 9999;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y;
      overscroll-behavior: contain;
      padding: 4px;
      opacity: 0;
      transform: scale(0.96) translateY(-4px);
      transition: opacity var(--transition-fast), transform var(--transition-fast);
    }
    #mention-popup.visible { opacity: 1; transform: scale(1) translateY(0); }
    #mention-popup::-webkit-scrollbar { width: 4px; }
    #mention-popup::-webkit-scrollbar-thumb { background: var(--scrollbar-thumb); border-radius: 2px; }
    #mention-popup::-webkit-scrollbar-track { background: transparent; }

    .popup-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      cursor: pointer;
      font-size: 14px;
      color: var(--text-primary);
      border-radius: 8px;
      transition: background-color var(--transition-fast);
    }
    .popup-item:hover { background-color: var(--bg-hover); }
    .popup-item:active { background-color: var(--bg-pressed); }
    .popup-item + .popup-item { margin-top: 2px; }
    .popup-item-avatar { width: 32px; height: 32px; object-fit: cover; flex-shrink: 0; }
    .popup-item-avatar.round { border-radius: 50%; }
    .popup-item-avatar.square { border-radius: 6px; }
    .popup-item-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  </style>
</head>
<body>
  <div id="editor" contenteditable="true" data-placeholder="${e}"></div>
  <div id="mention-popup"></div>
  <script>
    const editor = document.getElementById('editor');
    const mentionPopup = document.getElementById('mention-popup');
    let dataList = [];
    let currentTriggerChar = null;
    let currentRange = null;
    let mentionStartPos = null;
    let isComposing = false;
    let isAndroid = /Android/i.test((navigator.userAgent || ''));
    let platformStyleApplied = false;
    let controlledMention = false;
    let controlledHashTag = false;
    let lastCaretRange = null;
    let lastCaretPlainTextOffset = null;
    let lastEditorBlurAt = 0;
    let shouldRestoreFocusAfterRecentBlur = false;
    let skipFocusRestoreAfterBlur = false;
    let suppressNextDeleteBeforeInput = false;

    function postMessage(data) {
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }

    function getTagAnchorText() {
      // Android \u4E0A collapsed caret \u843D\u5728\u96F6\u5BBD\u5B57\u7B26\u9644\u8FD1\u65F6\u5BB9\u6613\u4E0D\u6E32\u67D3\uFF0C
      // \u8FD9\u91CC\u6539\u7528 NBSP \u4F5C\u4E3A tag \u951A\u70B9\uFF1B\u5BFC\u51FA\u7EAF\u6587\u672C\u65F6\u4F1A\u7EDF\u4E00\u5254\u9664\u3002
      return isAndroid ? '\xA0' : '\u200B';
    }

    function applyPlatformBehavior() {
      if (platformStyleApplied) return;
      platformStyleApplied = true;
      if (isAndroid) {
        // Android WebView \u653E\u5728\u5916\u5C42 ScrollView \u91CC\u65F6\uFF0C\u5185\u90E8 overflow \u5BB9\u5668\u6EDA\u52A8\u4E0D\u7A33\u5B9A\uFF1B
        // \u6539\u4E3A\u8BA9 WebView \u6587\u6863\u81EA\u8EAB\u6EDA\u52A8\uFF0C\u914D\u5408 RN WebView \u7684 nestedScrollEnabled\u3002
        document.documentElement.style.position = 'static';
        document.documentElement.style.height = 'auto';
        document.documentElement.style.minHeight = '100%';
        document.documentElement.style.overflow = 'auto';
        document.documentElement.style.touchAction = 'pan-y';
        document.body.style.position = 'static';
        document.body.style.height = 'auto';
        document.body.style.minHeight = '100%';
        document.body.style.overflow = 'visible';
        document.body.style.touchAction = 'pan-y';
        editor.style.flex = 'none';
        editor.style.height = 'auto';
        editor.style.minHeight = '100%';
        editor.style.overflowY = 'visible';
        return;
      }

      // iOS: \u7F29\u5C0F line-height \u964D\u4F4E\u5149\u6807\u9AD8\u5EA6; tag \u589E\u52A0\u5DE6\u53F3\u95F4\u8DDD
      var style = document.createElement('style');
      style.textContent = '#editor {font-size:15px;}';
      document.head.appendChild(style);
    }

    document.addEventListener('message', (event) => {
      try { handleMessage(typeof event.data === 'string' ? JSON.parse(event.data) : event.data); }
      catch (e) { console.error('Parse message error:', e); }
    });
    window.addEventListener('message', (event) => {
      try { handleMessage(typeof event.data === 'string' ? JSON.parse(event.data) : event.data); }
      catch (e) { console.error('Parse message error:', e); }
    });

    function createTagElement(triggerChar, item) {
      const tagEl = document.createElement('span');
      tagEl.className = 'tag ' + (triggerChar === '@' ? 'tag-at' : 'tag-hash');
      tagEl.contentEditable = 'false';
      tagEl.dataset.id = item.id;
      tagEl.dataset.name = item.name;
      tagEl.dataset.type = triggerChar;
      tagEl.innerHTML = (triggerChar === '@' ? '@' : '') + item.name;
      
      return tagEl;
    }

    function convertTextToMentions(html) {
      if (!html) return html;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      function processNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          const tagRegex = /([@#])\\{([^}]+)\\}/g;
          const allMatches = [];
          let match;
          while ((match = tagRegex.exec(text)) !== null) {
            const triggerChar = match[1];
            const id = match[2];
            const dataItem = dataList.find(m => m.id === id && m.type === triggerChar);
            if (dataItem) allMatches.push({ triggerChar, index: match.index, length: match[0].length, dataItem });
          }
          if (allMatches.length > 0) {
            const fragments = [];
            let lastIndex = 0;
            for (const m of allMatches) {
              if (m.index > lastIndex) {
                fragments.push(document.createTextNode(text.substring(lastIndex, m.index)));
              } else if (fragments.length === 0) {
                // tag \u662F\u7B2C\u4E00\u4E2A\u5143\u7D20\uFF0C\u524D\u9762\u6CA1\u6709\u6587\u672C\u8282\u70B9\u65F6\u8865\u4E00\u4E2A\u951A\u70B9\u6587\u672C\u8282\u70B9\u3002
                fragments.push(document.createTextNode(getTagAnchorText()));
              }
              fragments.push(createTagElement(m.triggerChar, m.dataItem));
              lastIndex = m.index + m.length;
            }
            if (lastIndex < text.length) fragments.push(document.createTextNode(text.substring(lastIndex)));
            const parent = node.parentNode;
            fragments.forEach(f => parent.insertBefore(f, node));
            parent.removeChild(node);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('tag')) {
          Array.from(node.childNodes).forEach(child => processNode(child));
        }
      }
      processNode(tempDiv);
      return tempDiv.innerHTML;
    }

    function handleMessage(data) {
      if (data.type === 'setContent') {
        const content = data.content || '';
        if (!content) {
          editor.innerHTML = '';
        } else {
          editor.innerHTML = convertTextToMentions(content);
          normalizeTagTextAnchors(editor);
        }
      } else if (data.type === 'setDataList') {
        dataList = data.dataList || [];
      } else if (data.type === 'setMentions') {
        dataList = (data.mentions || []).map(m => ({ type: '@', id: m.id, name: m.name, url: m.avatar }));
      } else if (data.type === 'getContent') {
        postMessage({ type: 'content', content: convertMentionsToText() });
      } else if (data.type === 'blur') {
        skipFocusRestoreAfterBlur = true;
        editor.blur();
      } else if (data.type === 'insertTag') {
        insertTag(data.item, data.triggerChar);
      } else if (data.type === 'insertTagAtCursor') {
        insertTagAtCursorOrAppend(data.item, data.triggerChar);
      } else if (data.type === 'insertTagAtCursorSilently') {
        insertTagAtCursorOrAppend(data.item, data.triggerChar, false);
      } else if (data.type === 'appendTagAtCursor') {
        appendTagAtCursor(data.item, data.triggerChar);
      } else if (data.type === 'replaceTag') {
        replaceTag(data.oldId, data.oldType, data.item, data.triggerChar);
      } else if (data.type === 'reparseContent') {
        const caretOffset = getPlainTextCaretOffset();
        const offsetToRestore = caretOffset !== null ? caretOffset : lastCaretPlainTextOffset;
        const plainText = convertMentionsToText();
        editor.innerHTML = convertTextToMentions(plainText);
        normalizeTagTextAnchors(editor);
        restoreCaretByPlainTextOffset(offsetToRestore);
      } else if (data.type === 'removeTagById') {
        const tags = editor.querySelectorAll('.tag');
        let removed = false;
        for (let i = 0; i < tags.length; i++) {
          if (tags[i].dataset.id === data.id) {
            const tagEl = tags[i];
            const parentNode = tagEl.parentNode;
            const nextSibling = tagEl.nextSibling;

            // \u5220\u9664\u6807\u7B7E\u540E\u9762\u7684\u5360\u4F4D\u7B26\uFF08\u96F6\u5BBD\u5B57\u7B26\uFF09\uFF0C\u4F46\u4FDD\u7559\u6362\u884C\u7B26\u548C\u5176\u4ED6\u5185\u5BB9
            if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE) {
              const text = nextSibling.textContent || '';
              // \u53EA\u5220\u9664\u5F00\u5934\u7684\u5355\u4E2A\u5360\u4F4D\u7B26\uFF0C\u4FDD\u7559\u6362\u884C\u7B26\u548C\u5176\u4ED6\u5B57\u7B26
              if (text.length > 0 && isTagSpacerChar(text[0])) {
                nextSibling.textContent = text.slice(1);
                // \u5982\u679C\u5220\u9664\u5360\u4F4D\u7B26\u540E\u6587\u672C\u8282\u70B9\u4E3A\u7A7A\uFF0C\u5219\u5220\u9664\u8BE5\u8282\u70B9
                if (nextSibling.textContent.length === 0) {
                  nextSibling.remove();
                }
              }
            }

            // \u5220\u9664\u6807\u7B7E\u524D\u9762\u7684\u5360\u4F4D\u7B26\uFF08\u96F6\u5BBD\u5B57\u7B26\uFF09\uFF0C\u4F46\u4FDD\u7559\u6362\u884C\u7B26\u548C\u5176\u4ED6\u5185\u5BB9
            const prevSibling = tagEl.previousSibling;
            if (prevSibling && prevSibling.nodeType === Node.TEXT_NODE) {
              const text = prevSibling.textContent || '';
              // \u53EA\u5220\u9664\u672B\u5C3E\u7684\u5355\u4E2A\u5360\u4F4D\u7B26\uFF0C\u4FDD\u7559\u6362\u884C\u7B26\u548C\u5176\u4ED6\u5B57\u7B26
              if (text.length > 0 && isTagSpacerChar(text[text.length - 1])) {
                prevSibling.textContent = text.slice(0, -1);
                // \u5982\u679C\u5220\u9664\u5360\u4F4D\u7B26\u540E\u6587\u672C\u8282\u70B9\u4E3A\u7A7A\uFF0C\u5219\u5220\u9664\u8BE5\u8282\u70B9
                if (prevSibling.textContent.length === 0) {
                  prevSibling.remove();
                }
              }
            }

            // \u5220\u9664\u6807\u7B7E\u672C\u8EAB
            tagEl.remove();
            removed = true;
          }
        }
        if (removed) notifyContentChange();
      } else if (data.type === 'setControlledMention') {
        controlledMention = !!data.value;
      } else if (data.type === 'setControlledHashTag') {
        controlledHashTag = !!data.value;
      }
    }

    function setCaretPosition(range) {
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      saveCaretSnapshot(range);
    }

    function setCollapsedCaret(container, offset) {
      const range = document.createRange();
      const maxOffset = container.nodeType === Node.TEXT_NODE
        ? container.textContent.length
        : container.childNodes.length;
      range.setStart(container, Math.max(0, Math.min(offset, maxOffset)));
      range.collapse(true);
      setCaretPosition(range);
    }

    function isTagSpacerChar(s) {
      return s === '\xA0' || s === '\u200B' || s === '\uFEFF' || s === ' ';
    }

    function isGeneratedTagAnchorChar(s) {
      return s === '\xA0' || s === '\u200B' || s === '\uFEFF';
    }

    function getLeadingTagSpacerCount(text) {
      let count = 0;
      while (count < text.length && isTagSpacerChar(text[count])) {
        count++;
      }
      return count;
    }

    function hasOnlyTagSpacers(text) {
      return !!text && getLeadingTagSpacerCount(text) === text.length;
    }

    function hasOnlyGeneratedTagAnchors(text) {
      if (!text) return false;
      for (let i = 0; i < text.length; i++) {
        if (!isGeneratedTagAnchorChar(text[i])) return false;
      }
      return true;
    }

    function getNodePlainTextLength(node) {
      if (!node) return 0;
      if (node.nodeType === Node.TEXT_NODE) {
        return (node.textContent || '').replace(/[\u200B\xA0\uFEFF]/g, '').length;
      }
      if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('tag')) {
        return ((node.dataset.type === '#' ? '#' : '@') + '{' + node.dataset.id + '}').length;
      }
      let length = 0;
      Array.from(node.childNodes || []).forEach(child => {
        length += getNodePlainTextLength(child);
      });
      return length;
    }

    function getPlainTextCaretOffset() {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return null;
      return getPlainTextOffsetFromRange(sel.getRangeAt(0));
    }

    function getPlainTextOffsetFromRange(range) {
      if (!range) return null;
      if (!editor.contains(range.startContainer)) return null;
      try {
        const beforeRange = document.createRange();
        beforeRange.setStart(editor, 0);
        beforeRange.setEnd(range.startContainer, range.startOffset);
        const tmp = document.createElement('div');
        tmp.appendChild(beforeRange.cloneContents());
        return getNodePlainTextLength(tmp);
      } catch (e) {
        return null;
      }
    }

    function saveCaretSnapshot(range) {
      if (!range || !range.collapsed) return;
      if (!editor.contains(range.startContainer)) return;
      lastCaretRange = range.cloneRange();
      const offset = getPlainTextOffsetFromRange(range);
      if (offset !== null) {
        lastCaretPlainTextOffset = offset;
      }
    }

    function getLiveEditorRange() {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return null;
      const range = sel.getRangeAt(0);
      if (!editor.contains(range.startContainer) || !editor.contains(range.endContainer)) return null;
      return range;
    }

    function getEditorInsertionRange() {
      const liveRange = getLiveEditorRange();
      if (liveRange) return liveRange;
      if (lastCaretRange && editor.contains(lastCaretRange.startContainer)) {
        return lastCaretRange.cloneRange();
      }
      if (lastCaretPlainTextOffset !== null) {
        restoreCaretByPlainTextOffset(lastCaretPlainTextOffset);
        return getLiveEditorRange();
      }
      return null;
    }

    function restoreLastCaretSnapshot() {
      if (lastCaretPlainTextOffset !== null) {
        restoreCaretByPlainTextOffset(lastCaretPlainTextOffset);
        const restoredRange = getLiveEditorRange();
        if (restoredRange) return restoredRange;
      }
      if (lastCaretRange && editor.contains(lastCaretRange.startContainer)) {
        const range = lastCaretRange.cloneRange();
        setCaretPosition(range);
        return range;
      }
      return null;
    }

    function resolveTagInsertionFocus(shouldFocus) {
      if (shouldFocus !== false) return true;
      if (document.activeElement === editor) return true;
      if (!shouldRestoreFocusAfterRecentBlur) return false;
      return Date.now() - lastEditorBlurAt < 400;
    }

    function restoreCaretByPlainTextOffset(targetOffset) {
      if (targetOffset == null) return;
      let remaining = targetOffset;
      let restored = false;

      function walk(node) {
        if (!node || restored) return;
        if (node.nodeType === Node.TEXT_NODE) {
          const rawText = node.textContent || '';
          const plainLength = rawText.replace(/[\u200B\xA0\uFEFF]/g, '').length;
          if (remaining <= plainLength) {
            let plainCount = 0;
            let rawOffset = 0;
            while (rawOffset < rawText.length && plainCount < remaining) {
              if (!isTagSpacerChar(rawText[rawOffset])) plainCount++;
              rawOffset++;
            }
            setCollapsedCaret(node, rawOffset);
            restored = true;
            return;
          }
          remaining -= plainLength;
          return;
        }
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('tag')) {
          const tagLength = ((node.dataset.type === '#' ? '#' : '@') + '{' + node.dataset.id + '}').length;
          if (remaining <= tagLength) {
            placeCaretAfterTag(node, false);
            restored = true;
            return;
          }
          remaining -= tagLength;
          return;
        }
        Array.from(node.childNodes || []).forEach(child => walk(child));
      }

      walk(editor);
      if (!restored && editor.lastChild) {
        if (editor.lastChild.nodeType === Node.ELEMENT_NODE && editor.lastChild.classList.contains('tag')) {
          placeCaretAfterTag(editor.lastChild, false);
        } else if (editor.lastChild.nodeType === Node.TEXT_NODE) {
          setCollapsedCaret(editor.lastChild, editor.lastChild.textContent.length);
        } else {
          setCollapsedCaret(editor, editor.childNodes.length);
        }
      }
    }

    function restoreCaretAfterRemoval(parentNode, nextSibling) {
      if (!parentNode) return;
      // \u4F18\u5148\u628A\u5149\u6807\u653E\u56DE\u5220\u9664\u70B9\u540E\u9762\u7684\u6587\u672C\u8282\u70B9\u8D77\u70B9\uFF0C\u8FD9\u6837\u5220\u9664\u6700\u540E\u4E00\u4E2A\u6807\u7B7E\u65F6\u4E0D\u4F1A\u8DF3\u5230\u5F00\u5934\u3002
      if (nextSibling && nextSibling.parentNode === parentNode && nextSibling.nodeType === Node.TEXT_NODE) {
        setCollapsedCaret(nextSibling, 0);
        return;
      }
      const prevSibling = nextSibling && nextSibling.parentNode === parentNode
        ? nextSibling.previousSibling
        : parentNode.lastChild;
      if (prevSibling && prevSibling.nodeType === Node.TEXT_NODE) {
        setCollapsedCaret(prevSibling, prevSibling.textContent.length);
        return;
      }
      // \u524D\u540E\u90FD\u6CA1\u6709\u53EF\u627F\u8F7D\u5149\u6807\u7684\u6587\u672C\u8282\u70B9\u65F6\uFF0C\u8865\u4E00\u4E2A\u96F6\u5BBD\u5B57\u7B26\u5360\u4F4D\uFF0C\u907F\u514D\u6D4F\u89C8\u5668\u91CD\u7B97\u9009\u533A\u4F4D\u7F6E\u3002
      const marker = document.createTextNode(getTagAnchorText());
      parentNode.insertBefore(marker, nextSibling || null);
      setCollapsedCaret(marker, marker.textContent.length);
    }

    function removeLeadingSpacerChar(textNode) {
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return null;
      const text = textNode.textContent || '';
      if (!text || !isTagSpacerChar(text[0])) return textNode;
      const remainingText = text.slice(1);
      if (remainingText.length > 0) {
        textNode.textContent = remainingText;
        return textNode;
      }
      const nextSibling = textNode.nextSibling;
      textNode.remove();
      return nextSibling;
    }

    function removeLeadingTagSpacers(textNode) {
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return null;
      const text = textNode.textContent || '';
      const leadingSpacerCount = getLeadingTagSpacerCount(text);
      if (leadingSpacerCount === 0) return textNode;
      const remainingText = text.slice(leadingSpacerCount);
      if (remainingText.length > 0) {
        textNode.textContent = remainingText;
        return textNode;
      }
      const nextSibling = textNode.nextSibling;
      textNode.remove();
      return nextSibling;
    }

    function getCaretOffsetAfterTag(textNode) {
      if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return 0;
      const text = textNode.textContent || '';
      // \u5982\u679C\u6807\u7B7E\u540E\u9762\u5DF2\u6709\u5360\u4F4D\u5B57\u7B26\uFF0C\u5219\u628A\u5149\u6807\u653E\u5230\u5360\u4F4D\u5B57\u7B26\u540E\uFF1B\u5426\u5219\u653E\u5230\u6587\u672C\u8D77\u70B9\u3002
      return text.length > 0 && isTagSpacerChar(text[0])
        ? 1
        : 0;
    }

    function ensureTextAnchorBeforeTag(tagEl) {
      if (!tagEl || !tagEl.parentNode) return null;
      if (!tagEl.previousSibling || tagEl.previousSibling.nodeType !== Node.TEXT_NODE) {
        tagEl.parentNode.insertBefore(document.createTextNode(getTagAnchorText()), tagEl);
      } else if (hasOnlyGeneratedTagAnchors(tagEl.previousSibling.textContent || '')) {
        tagEl.previousSibling.textContent = getTagAnchorText();
      }
      return tagEl.previousSibling;
    }

    function ensureTextAnchorAfterTag(tagEl) {
      if (!tagEl || !tagEl.parentNode) return null;
      let nextTextNode = tagEl.nextSibling;
      if (!nextTextNode || nextTextNode.nodeType !== Node.TEXT_NODE) {
        nextTextNode = document.createTextNode(getTagAnchorText());
        tagEl.parentNode.insertBefore(nextTextNode, tagEl.nextSibling);
      } else if (!nextTextNode.textContent) {
        nextTextNode.textContent = getTagAnchorText();
      } else if (hasOnlyGeneratedTagAnchors(nextTextNode.textContent || '')) {
        nextTextNode.textContent = getTagAnchorText();
      }
      return nextTextNode;
    }

    function normalizeTagTextAnchors(root) {
      const tags = (root || editor).querySelectorAll('.tag');
      for (let i = 0; i < tags.length; i++) {
        ensureTextAnchorBeforeTag(tags[i]);
        ensureTextAnchorAfterTag(tags[i]);
      }
    }

    function isTagElement(el) {
      return el && el.nodeType === Node.ELEMENT_NODE && el.classList.contains('tag');
    }

    function handleTagDeletion(direction) {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return false;
      const range = sel.getRangeAt(0);
      if (!range.collapsed) return false;

      const node = range.startContainer;
      const leadingSpacerCount = node.nodeType === Node.TEXT_NODE
        ? getLeadingTagSpacerCount(node.textContent || '')
        : 0;

      if (direction === 'backward') {
        if (node.nodeType === Node.TEXT_NODE && range.startOffset === 0 && isTagElement(node.previousSibling)) {
          const tagToRemove = node.previousSibling;
          const caretOffsetBeforeTag = getPlainTextCaretOffset() - getNodePlainTextLength(tagToRemove);
          tagToRemove.remove();
          restoreCaretByPlainTextOffset(caretOffsetBeforeTag);
          notifyContentChange();
          return true;
        }
        if (node.nodeType === Node.ELEMENT_NODE && isTagElement(node.childNodes[range.startOffset - 1])) {
          const tagToRemove = node.childNodes[range.startOffset - 1];
          const caretOffsetBeforeTag = getPlainTextCaretOffset() - getNodePlainTextLength(tagToRemove);
          tagToRemove.remove();
          restoreCaretByPlainTextOffset(caretOffsetBeforeTag);
          notifyContentChange();
          return true;
        }
        if (node.nodeType === Node.TEXT_NODE && leadingSpacerCount > 0 && range.startOffset <= leadingSpacerCount && isTagElement(node.previousSibling)) {
          const tagToRemove = node.previousSibling;
          const beforeTag = tagToRemove.previousSibling;
          const caretOffsetBeforeTag = getPlainTextCaretOffset() - getNodePlainTextLength(tagToRemove);
          tagToRemove.remove();
          removeLeadingTagSpacers(node);
          if (beforeTag && beforeTag.nodeType === Node.TEXT_NODE && hasOnlyTagSpacers(beforeTag.textContent || '')) beforeTag.remove();
          restoreCaretByPlainTextOffset(caretOffsetBeforeTag);
          notifyContentChange();
          return true;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          const prev = range.startOffset > 0 ? node.childNodes[range.startOffset - 1] : null;
          if (prev && prev.nodeType === Node.TEXT_NODE && hasOnlyTagSpacers(prev.textContent || '') && isTagElement(prev.previousSibling)) {
            const tagToRemove = prev.previousSibling;
            const caretOffsetBeforeTag = getPlainTextCaretOffset() - getNodePlainTextLength(tagToRemove);
            tagToRemove.remove();
            removeLeadingTagSpacers(prev);
            restoreCaretByPlainTextOffset(caretOffsetBeforeTag);
            notifyContentChange();
            return true;
          }
        }
      }

      if (direction === 'forward') {
        if (node.nodeType === Node.TEXT_NODE && range.startOffset === node.textContent.length && isTagElement(node.nextSibling)) {
          const tagToRemove = node.nextSibling;
          const spacerNode = tagToRemove.nextSibling;
          const currentOffset = getPlainTextCaretOffset();
          tagToRemove.remove();
          if (spacerNode && spacerNode.nodeType === Node.TEXT_NODE && getLeadingTagSpacerCount(spacerNode.textContent || '') > 0) {
            removeLeadingTagSpacers(spacerNode);
          }
          restoreCaretByPlainTextOffset(currentOffset);
          notifyContentChange();
          return true;
        }
        if (node.nodeType === Node.ELEMENT_NODE && isTagElement(node.childNodes[range.startOffset])) {
          const tagToRemove = node.childNodes[range.startOffset];
          const spacerNode = tagToRemove.nextSibling;
          const currentOffset = getPlainTextCaretOffset();
          tagToRemove.remove();
          if (spacerNode && spacerNode.nodeType === Node.TEXT_NODE && getLeadingTagSpacerCount(spacerNode.textContent || '') > 0) {
            removeLeadingTagSpacers(spacerNode);
          }
          restoreCaretByPlainTextOffset(currentOffset);
          notifyContentChange();
          return true;
        }
      }

      return false;
    }

    function placeCaretAfterTag(tagEl, shouldScroll, shouldFocus) {
      if (shouldFocus !== false) {
        editor.focus();
      }
      const nextTextNode = ensureTextAnchorAfterTag(tagEl);
      if (!nextTextNode) return;
      if (isAndroid && tagEl && tagEl.parentNode) {
        const parentNode = tagEl.parentNode;
        const tagIndex = Array.prototype.indexOf.call(parentNode.childNodes, tagEl);
        if (tagIndex > -1) {
          setCollapsedCaret(parentNode, tagIndex + 1);
        }
      } else {
        setCollapsedCaret(nextTextNode, getCaretOffsetAfterTag(nextTextNode));
      }
      if (shouldScroll) {
        requestAnimationFrame(() => {
          scrollToCaret();
        });
      }
    }

    function placeCaretBeforeTag(tagEl, shouldFocus) {
      if (!tagEl) return;
      if (shouldFocus !== false) {
        editor.focus();
      }
      const prevTextNode = ensureTextAnchorBeforeTag(tagEl);
      if (!prevTextNode) return;
      if (isAndroid && tagEl.parentNode) {
        const parentNode = tagEl.parentNode;
        const tagIndex = Array.prototype.indexOf.call(parentNode.childNodes, tagEl);
        if (tagIndex > -1) {
          setCollapsedCaret(parentNode, tagIndex);
          return;
        }
      }
      setCollapsedCaret(prevTextNode, prevTextNode.textContent.length);
    }

    function insertTag(item, triggerChar) {
      if (!currentRange) return;

      // \u4FDD\u5B58\u63D2\u5165\u4F4D\u7F6E\u7684\u7236\u8282\u70B9\u548C\u504F\u79FB\u91CF
      let insertContainer = currentRange.startContainer;
      let insertOffset = currentRange.startOffset;

      if (mentionStartPos) {
        insertContainer = mentionStartPos.startContainer;
        insertOffset = mentionStartPos.startOffset;
        currentRange.setStart(insertContainer, insertOffset);
        currentRange.deleteContents();
      }

      const tagEl = createTagElement(triggerChar, item);
      // \u5148\u63D2\u5165\u6807\u7B7E
      currentRange.insertNode(tagEl);

      // \u786E\u4FDD tag \u524D\u9762\u6709\u6587\u672C\u8282\u70B9\uFF0CiOS \u9009\u533A\u62D6\u62FD\u9700\u8981\u951A\u70B9
      ensureTextAnchorBeforeTag(tagEl);
      placeCaretAfterTag(tagEl, true, true);

      hideMentionPopup();
      notifyContentChange();
    }

    function insertTagAtCursorOrAppend(item, triggerChar, shouldFocus) {
      const nextShouldFocus = resolveTagInsertionFocus(shouldFocus);
      // \u5C1D\u8BD5\u83B7\u53D6\u5F53\u524D\u5149\u6807\u4F4D\u7F6E
      const range = getEditorInsertionRange();
      if (range) {
        const tagEl = createTagElement(triggerChar, item);
        // \u5982\u679C\u6709\u9009\u533A\u5185\u5BB9\u5148\u5220\u9664
        if (!range.collapsed) {
          range.deleteContents();
        }
        range.insertNode(tagEl);
        // \u786E\u4FDD tag \u524D\u9762\u6709\u6587\u672C\u8282\u70B9
        ensureTextAnchorBeforeTag(tagEl);
        placeCaretAfterTag(tagEl, true, nextShouldFocus);
        notifyContentChange();
        return;
      }
      // \u6CA1\u6709\u6709\u6548\u5149\u6807\uFF0C\u8FFD\u52A0\u5230\u672B\u5C3E
      appendTagAtCursor(item, triggerChar, true, nextShouldFocus);
    }

    function appendTagAtCursor(item, triggerChar, shouldPlaceCaret, shouldFocus) {
      // \u4E0D\u4F9D\u8D56\u5F53\u524D\u5149\u6807\uFF0C\u59CB\u7EC8\u5C06\u6807\u7B7E\u76F4\u63A5\u8FFD\u52A0\u5230\u672B\u5C3E\u3002
      // \u4EC5\u5728\u7F16\u8F91\u5668\u5B9E\u9645\u4E0A\u4E3A\u7A7A\u65F6\uFF0C\u6E05\u6389\u6D4F\u89C8\u5668\u81EA\u52A8\u8865\u7684\u5360\u4F4D <br>\uFF0C\u907F\u514D\u9996\u6B21\u8FFD\u52A0\u65F6\u524D\u9762\u591A\u4E00\u4E2A\u6362\u884C\u3002
      const hasTag = !!editor.querySelector('.tag');
      const plainText = convertMentionsToText();
      const normalizedText = plainText.replace(/[\\u200B\\u00A0\\uFEFF\\n\\r ]/g, '');
      const onlyPlaceholderBr =
        editor.childNodes.length === 1 &&
        editor.firstChild &&
        editor.firstChild.nodeType === Node.ELEMENT_NODE &&
        editor.firstChild.tagName === 'BR';
      if (!hasTag && !normalizedText && onlyPlaceholderBr) {
        editor.innerHTML = '';
      }
      
      const tagEl = createTagElement(triggerChar, item);

      // \u627E\u5230\u771F\u6B63\u7684\u6700\u540E\u4E00\u4E2A\u5B50\u8282\u70B9\u3002\u5982\u679C\u5B83\u662F\u5757\u7EA7\u5143\u7D20(\u5982 div/p)\uFF0C\u5E94\u8BE5\u8FFD\u52A0\u5230\u5B83\u7684\u5185\u90E8
      const lastChild = editor.lastChild;
      if (lastChild && lastChild.nodeType === Node.ELEMENT_NODE && ['DIV', 'P', 'LI'].indexOf(lastChild.tagName) > -1) {
        // \u5982\u679C\u6700\u540E\u4E00\u884C\u521A\u597D\u662F\u4E2A\u53EA\u6709 <br> \u7684\u7A7A\u884C\u5757\uFF0C\u5148\u6E05\u6389 <br>\uFF0C\u8BA9\u5143\u7D20\u8D34\u8FB9
        if (lastChild.childNodes.length === 1 && lastChild.firstChild.tagName === 'BR') {
          lastChild.innerHTML = '';
        }
        // \u786E\u4FDD tag \u524D\u9762\u6709\u6587\u672C\u8282\u70B9\uFF0CiOS \u9009\u533A\u62D6\u62FD\u9700\u8981\u951A\u70B9
        if (!lastChild.lastChild || lastChild.lastChild.nodeType !== Node.TEXT_NODE) {
          lastChild.appendChild(document.createTextNode(getTagAnchorText()));
        }
        lastChild.appendChild(tagEl);
      } else {
        // \u786E\u4FDD tag \u524D\u9762\u6709\u6587\u672C\u8282\u70B9
        if (!editor.lastChild || editor.lastChild.nodeType !== Node.TEXT_NODE) {
          editor.appendChild(document.createTextNode(getTagAnchorText()));
        }
        editor.appendChild(tagEl);
      }

      if (shouldPlaceCaret) {
        placeCaretAfterTag(tagEl, true, shouldFocus);
      }

      notifyContentChange();
    }

    function replaceTag(oldId, oldType, newItem, triggerChar) {
      const tags = editor.querySelectorAll('.tag');
      let replaced = false;
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        if (tag.dataset.id === oldId && tag.dataset.type === oldType) {
          const newTagEl = createTagElement(triggerChar, newItem);
          tag.parentNode.replaceChild(newTagEl, tag);
          replaced = true;
          break;
        }
      }
      if (replaced) {
        notifyContentChange();
      }
    }

    function calculatePopupPosition(caretRect, itemCount) {
      const vh = window.innerHeight, vw = window.innerWidth;
      const popupW = 200, pad = 12;
      let x = caretRect.left;
      if (x + popupW > vw - pad) x = Math.max(pad, vw - popupW - pad);
      if (x < pad) x = pad;
      const itemH = 48, desired = (itemCount || 1) * itemH + 8;
      const below = vh - caretRect.bottom - pad * 2;
      const above = caretRect.top - pad * 2;
      let y, maxH;
      if (below >= Math.min(desired, 240)) { y = caretRect.bottom + pad; maxH = Math.min(desired, below); }
      else if (above > below) { maxH = Math.min(desired, above); y = caretRect.top - pad - maxH; }
      else { y = caretRect.bottom + pad; maxH = Math.min(desired, below); }
      if (y < pad) y = pad;
      mentionPopup.style.maxHeight = Math.max(maxH, 100) + 'px';
      return { x, y };
    }

    function showPopup(items, triggerChar, caretRect) {
      if (items.length === 0) { hideMentionPopup(); return; }
      const pos = calculatePopupPosition(caretRect, items.length);
      // \u7EDF\u4E00\u4F7F\u7528\u539F\u751F\u5F39\u7A97\uFF0C\u901A\u77E5\u4E0A\u5C42
      postMessage({ type: 'popupShow', items, triggerChar, x: pos.x, y: pos.y, maxHeight: parseInt(mentionPopup.style.maxHeight) || 240 });
    }

    function hideMentionPopup() {
      mentionPopup.classList.remove('visible');
      setTimeout(() => { mentionPopup.style.display = 'none'; }, 150);
      mentionStartPos = null;
      currentTriggerChar = null;
      // \u7EDF\u4E00\u901A\u77E5\u4E0A\u5C42\u5173\u95ED\u5F39\u7A97\uFF08\u4E0D\u518D\u533A\u5206\u5E73\u53F0\uFF09
      postMessage({ type: 'popupHide' });
    }

    function convertMentionsToText() {
      const tmp = document.createElement('div');
      tmp.innerHTML = editor.innerHTML;
      tmp.querySelectorAll('.tag').forEach(el => {
        const t = el.dataset.type === '#' ? '#' : '@';
        el.parentNode.replaceChild(document.createTextNode(t + '{' + el.dataset.id + '}'), el);
      });
      return (tmp.innerText || '').replace(/[\u200B\xA0\uFEFF]/g, '');
    }

    function findDataItemName(type, id) {
      const item = dataList.find(m => String(m.id) === String(id) && m.type === type);
      return item && item.name ? item.name : '';
    }

    function getTagCopyText(el) {
      const type = el.dataset.type === '#' ? '#' : '@';
      const id = el.dataset.id;
      return el.dataset.name || findDataItemName(type, id) || '';
    }

    function replaceTagTokensWithNames(text) {
      return (text || '').replace(/([@#]){([^}]+)}/g, (match, type, id) => {
        return findDataItemName(type, id) || match;
      });
    }

    function getSelectionCopyText(range) {
      const tmp = document.createElement('div');
      tmp.appendChild(range.cloneContents());
      tmp.querySelectorAll('.tag').forEach(el => {
        el.parentNode.replaceChild(document.createTextNode(getTagCopyText(el)), el);
      });
      const text = (tmp.innerText || tmp.textContent || '').replace(/[\u200B\xA0\uFEFF]/g, '');
      return replaceTagTokensWithNames(text);
    }

    function notifyContentChange() {
      const plainText = convertMentionsToText();
      postMessage({ type: 'change', content: plainText, text: plainText });
    }
    let _notifyTimer = null;
    function debouncedNotifyContentChange() {
      if (_notifyTimer) clearTimeout(_notifyTimer);
      _notifyTimer = setTimeout(notifyContentChange, 100);
    }

    editor.addEventListener('compositionstart', () => { isComposing = true; });
    editor.addEventListener('compositionend', () => { isComposing = false; debouncedNotifyContentChange(); });

    editor.addEventListener('input', () => {
      if (isComposing) return;
      const sel = window.getSelection();
      if (sel.rangeCount === 0) return;
      const range = sel.getRangeAt(0);
      const textNode = range.startContainer;
      if (textNode.nodeType === Node.TEXT_NODE) {
        const text = textNode.textContent;
        const offset = range.startOffset;
        const ch = text[offset - 1];
        if (ch === '@' || ch === '#') {
          const isControlled = (ch === '@' && controlledMention) || (ch === '#' && controlledHashTag);
          currentTriggerChar = ch;
          currentRange = range.cloneRange();
          mentionStartPos = range.cloneRange();
          mentionStartPos.setStart(textNode, offset - 1);
          if (isControlled) {
            const caretRect = range.getBoundingClientRect();
            postMessage({ type: 'mentionTrigger', triggerChar: ch, cursorX: caretRect.left, cursorY: caretRect.bottom });
          } else {
            showPopup(dataList.filter(item => item.type === ch), ch, range.getBoundingClientRect());
          }
        } else if (currentTriggerChar && mentionStartPos) {
          // \u6B63\u5728\u8F93\u5165\u641C\u7D22\u5173\u952E\u5B57\uFF0C\u8FC7\u6EE4\u5F39\u7A97\u5217\u8868
          const searchStart = mentionStartPos.startOffset + 1; // \u8DF3\u8FC7\u89E6\u53D1\u5B57\u7B26\u672C\u8EAB
          const keyword = text.substring(searchStart, offset);
          const filtered = dataList.filter(item => item.type === currentTriggerChar && item.name.toLowerCase().includes(keyword.toLowerCase()));
          if (filtered.length > 0 && keyword.length < 20) {
            currentRange = range.cloneRange();
            showPopup(filtered, currentTriggerChar, range.getBoundingClientRect());
          } else {
            hideMentionPopup();
          }
        } else {
          hideMentionPopup();
        }
      } else {
        // \u975E TEXT_NODE \u573A\u666F\u4E5F\u5173\u95ED\u5F39\u7A97
        hideMentionPopup();
      }
      debouncedNotifyContentChange();
    });

    editor.addEventListener('copy', (e) => {
      const sel = window.getSelection();
      if (sel.rangeCount === 0) return;
      const clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;
      e.preventDefault();
      clipboardData.setData('text/plain', getSelectionCopyText(sel.getRangeAt(0)));
    });

    editor.addEventListener('cut', (e) => {
      const sel = window.getSelection();
      if (sel.rangeCount === 0) return;
      const range = sel.getRangeAt(0);
      const clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;
      e.preventDefault();
      clipboardData.setData('text/plain', getSelectionCopyText(range));
      range.deleteContents();
      notifyContentChange();
    });

    editor.addEventListener('paste', (e) => {
      e.preventDefault();
      const text = (e.clipboardData || window.clipboardData).getData('text/plain');
      if (/([@#])\\{[^}]+\\}/.test(text) && dataList.length > 0) {
        const sel = window.getSelection();
        if (sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0);
        range.deleteContents();
        const tmp = document.createElement('div');
        tmp.textContent = text;
        tmp.innerHTML = convertTextToMentions(tmp.innerHTML);
        const frag = document.createDocumentFragment();
        while (tmp.firstChild) frag.appendChild(tmp.firstChild);
        range.insertNode(frag);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
      } else {
        document.execCommand('insertText', false, text);
      }
      notifyContentChange();
      // \u7C98\u8D34\u540E\u5C06\u5149\u6807\u6EDA\u52A8\u5230\u53EF\u89C1\u8303\u56F4\u5185
      scrollToCaret();
    });

    /** \u5982\u679C\u5149\u6807\u4E0D\u5728 editor \u53EF\u89C1\u533A\u57DF\u5185\uFF0C\u6EDA\u52A8 editor \u4F7F\u5149\u6807\u53EF\u89C1 */
    function scrollToCaret() {
      requestAnimationFrame(() => {
        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0).cloneRange();
        const restoreRange = range.cloneRange();
        range.collapse(false);
        // \u63D2\u5165\u4E34\u65F6\u96F6\u5BBD\u5143\u7D20\u6765\u83B7\u53D6\u51C6\u786E\u4F4D\u7F6E\uFF08collapsed range \u5728\u67D0\u4E9B WebKit \u4E0B rect \u4E3A\u7A7A\uFF09
        const marker = document.createElement('span');
        marker.textContent = '\\u200B';
        range.insertNode(marker);
        const rect = marker.getBoundingClientRect();
        const editorRect = editor.getBoundingClientRect();
        marker.parentNode.removeChild(marker);
        setCaretPosition(restoreRange);
        if (isAndroid) {
          const viewportTop = 0;
          const viewportBottom = window.innerHeight || document.documentElement.clientHeight;
          if (rect.bottom > viewportBottom) {
            window.scrollBy(0, rect.bottom - viewportBottom + 12);
          } else if (rect.top < viewportTop) {
            window.scrollBy(0, rect.top - viewportTop - 12);
          }
          return;
        }
        // \u5149\u6807\u5728 editor \u53EF\u89C1\u533A\u57DF\u4E0B\u65B9
        if (rect.bottom > editorRect.bottom) {
          editor.scrollTop += rect.bottom - editorRect.bottom;
        }
        // \u5149\u6807\u5728 editor \u53EF\u89C1\u533A\u57DF\u4E0A\u65B9
        else if (rect.top < editorRect.top) {
          editor.scrollTop -= editorRect.top - rect.top;
        }
      });
    }

    let popupTouchStartY = 0;
    mentionPopup.addEventListener('touchstart', (e) => { popupTouchStartY = e.touches[0].clientY; e.stopPropagation(); }, { passive: false });
    mentionPopup.addEventListener('touchmove', (e) => {
      e.stopPropagation();
      const st = mentionPopup.scrollTop, sh = mentionPopup.scrollHeight, ch = mentionPopup.clientHeight;
      const dy = e.touches[0].clientY - popupTouchStartY;
      if (sh <= ch) { e.preventDefault(); return; }
      if ((st <= 0 && dy > 0) || (st + ch >= sh && dy < 0)) e.preventDefault();
    }, { passive: false });
    mentionPopup.addEventListener('touchend', (e) => { e.stopPropagation(); }, { passive: true });

    document.addEventListener('click', (e) => {
      if (!mentionPopup.contains(e.target) && e.target !== editor) hideMentionPopup();
    });

    editor.addEventListener('focus', () => {
      shouldRestoreFocusAfterRecentBlur = false;
      skipFocusRestoreAfterBlur = false;
      var sel = window.getSelection();
      const liveRange = getLiveEditorRange();
      const shouldRestoreRecentCaret =
        Date.now() - lastEditorBlurAt < 1200 &&
        (!liveRange || getParentTag(liveRange.startContainer));

      if (shouldRestoreRecentCaret && restoreLastCaretSnapshot()) {
        postMessage({ type: 'focus' });
        return;
      }

      // \u5982\u679C\u6CA1\u6709\u5DF2\u6709\u7684\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u5185\u5BB9\u672B\u5C3E
      if (sel && (sel.rangeCount === 0 || !editor.contains(sel.anchorNode))) {
        var range = document.createRange();
        var lastNode = editor.lastChild;
        if (lastNode) {
          if (lastNode.nodeType === Node.ELEMENT_NODE && lastNode.classList.contains('tag')) {
            placeCaretAfterTag(lastNode, false);
            postMessage({ type: 'focus' });
            return;
          } else if (lastNode.nodeType === Node.TEXT_NODE) {
            range.setStart(lastNode, lastNode.textContent.length);
          } else {
            range.setStartAfter(lastNode);
          }
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
      postMessage({ type: 'focus' });
    });
    editor.addEventListener('blur', () => {
      const liveRange = getLiveEditorRange();
      if (liveRange && liveRange.collapsed) {
        saveCaretSnapshot(liveRange);
      }
      lastEditorBlurAt = Date.now();
      shouldRestoreFocusAfterRecentBlur = !skipFocusRestoreAfterBlur;
      skipFocusRestoreAfterBlur = false;
      postMessage({ type: 'blur' });
    });

    // iOS: \u5728 document \u5C42\u9762\u5F7B\u5E95\u963B\u6B62\u6240\u6709 touchmove\uFF0C
    // \u53EA\u6709\u89E6\u6478\u76EE\u6807\u5728\u53EF\u6EDA\u52A8\u5BB9\u5668\uFF08editor / mentionPopup\uFF09\u5185\u90E8\u65F6\u624D\u653E\u884C
    function isInsideScrollable(el) {
      while (el && el !== document.documentElement) {
        if (el === editor || el === mentionPopup) return true;
        el = el.parentNode;
      }
      return false;
    }

    // editor \u5185\u90E8\u4E5F\u8981\u9632\u6B62 overscroll \u7A7F\u900F\uFF1A\u6EDA\u5230\u9876/\u5E95\u65F6\u963B\u6B62\u7EE7\u7EED\u6ED1\u52A8
    let editorTouchStartY = 0;
    editor.addEventListener('touchstart', (e) => {
      editorTouchStartY = e.touches[0].clientY;
    }, { passive: true });

    editor.addEventListener('touchmove', (e) => {
      // \u5982\u679C\u5F53\u524D\u9875\u9762\u5904\u4E8E\u9009\u4E2D\u72B6\u6001\uFF0C\u6216\u8005\u662F\u591A\u70B9\u89E6\u63A7\uFF0C\u4E0D\u62E6\u622A touchmove\uFF0C\u907F\u514D\u7834\u574F\u9009\u533A\u62D6\u62FD
      if (window.getSelection() && window.getSelection().toString().length > 0) {
        return;
      }
      if (e.touches.length > 1) {
        return;
      }

      const st = editor.scrollTop;
      const sh = editor.scrollHeight;
      const ch = editor.clientHeight;
      const dy = e.touches[0].clientY - editorTouchStartY;
      
      // \u5185\u5BB9\u4E0D\u8DB3\u4EE5\u6EDA\u52A8\u65F6
      if (sh <= ch) {
        // Android \u4E0A\u4E0D\u963B\u6B62\u9ED8\u8BA4\u884C\u4E3A
        // iOS \u4E0A\u5982\u679C\u4E0D\u963B\u6B62\u9ED8\u8BA4\u884C\u4E3A\u4F1A\u5BFC\u81F4\u6A61\u76AE\u7B4B\u6548\u679C\uFF0C\u4F46\u5982\u679C\u963B\u6B62\u4E86\u4F1A\u5BFC\u81F4\u9009\u533A\u65E0\u6CD5\u62D6\u62FD\u3002
        // \u56E0\u4E3A\u524D\u9762\u5DF2\u7ECF\u653E\u884C\u4E86\u9009\u4E2D\u72B6\u6001\uFF0C\u6240\u4EE5\u8FD9\u91CC\u53EF\u4EE5\u4FDD\u7559\u539F\u903B\u8F91\u3002
        if (!isAndroid) { e.preventDefault(); }
        return;
      }
      // \u5DF2\u7ECF\u6EDA\u5230\u9876\u90E8\u8FD8\u5728\u5F80\u4E0B\u62C9\uFF0C\u6216\u8005\u6EDA\u5230\u5E95\u90E8\u8FD8\u5728\u5F80\u4E0A\u62C9 \u2192 \u963B\u6B62\uFF08\u9632\u6B62\u7A7F\u900F\u5230\u9875\u9762\uFF09
      if ((st <= 0 && dy > 0) || (st + ch >= sh - 1 && dy < 0)) {
        if (!isAndroid) { e.preventDefault(); }
      }
    }, { passive: false });

    document.addEventListener('touchmove', (e) => {
      // \u540C\u6837\uFF0C\u5982\u679C\u6709\u9009\u533A\u5B58\u5728\uFF0C\u4E0D\u8981\u62E6\u622A
      if (window.getSelection() && window.getSelection().toString().length > 0) {
        return;
      }
      // Android\u4E0Aeditor\u5185\u90E8\u7684\u89E6\u6478\u4E8B\u4EF6\u4E0D\u62E6\u622A\uFF0C\u8BA9\u539F\u751F\u6EDA\u52A8\u6B63\u5E38\u5DE5\u4F5C
      if (isAndroid && isInsideScrollable(e.target)) return;
      if (!isInsideScrollable(e.target)) {
        if (!isAndroid) { e.preventDefault(); }
      }
    }, { passive: false });

    // \u4F7F\u7528 visualViewport \u76D1\u542C iOS \u952E\u76D8\u5F39\u51FA\u5BFC\u81F4\u7684 viewport \u504F\u79FB\uFF0C\u5F3A\u5236\u5F52\u96F6
    if (!isAndroid && window.visualViewport) {
      window.visualViewport.addEventListener('scroll', () => {
        if (window.visualViewport.offsetTop !== 0 || window.visualViewport.offsetLeft !== 0) {
          window.scrollTo(0, 0);
        }
      });
      window.visualViewport.addEventListener('resize', () => {
        window.scrollTo(0, 0);
      });
    }

    // \u515C\u5E95\uFF1A\u5982\u679C window \u8FD8\u662F\u53D1\u751F\u4E86\u6EDA\u52A8\uFF0C\u7ACB\u5373\u5F52\u96F6
    window.addEventListener('scroll', () => {
      if (!isAndroid) {
        window.scrollTo(0, 0);
      }
    });

    editor.addEventListener('scroll', () => {
      if (mentionPopup.style.display === 'block' && currentRange) {
        const pos = calculatePopupPosition(currentRange.getBoundingClientRect(), mentionPopup.querySelectorAll('.popup-item').length);
        mentionPopup.style.left = pos.x + 'px';
        mentionPopup.style.top = pos.y + 'px';
      }
    });

    editor.addEventListener('keydown', (e) => {
      // Escape \u952E\u5173\u95ED\u5F39\u7A97
      if (e.key === 'Escape') {
        hideMentionPopup();
        return;
      }

      // \u5F39\u7A97\u53EF\u89C1\u65F6\uFF0C\u6309\u4E0B\u4EFB\u610F\u952E\uFF08\u865A\u62DF\u952E\u76D8\u6309\u94AE\u3001\u5220\u9664\u952E\u7B49\uFF09\u90FD\u5173\u95ED\u5F39\u7A97
      if (currentTriggerChar) {
        hideMentionPopup();
      }

      if (e.key !== 'Backspace' && e.key !== 'Delete') return;
      if (e.key === 'Backspace') {
        if (handleTagDeletion('backward')) {
          e.preventDefault();
          suppressNextDeleteBeforeInput = true;
          return;
        }
      }

      if (e.key === 'Delete') {
        if (handleTagDeletion('forward')) {
          e.preventDefault();
          suppressNextDeleteBeforeInput = true;
          return;
        }
      }
    });

    // \u901A\u8FC7\u89E6\u6478\u5750\u6807\u624B\u52A8\u5B9A\u4F4D\u5149\u6807\uFF0C\u89E3\u51B3 WebView \u4E2D\u70B9\u51FB\u4E0D\u79FB\u52A8\u5149\u6807\u7684\u95EE\u9898
    function setCaretFromPoint(x, y) {
      let range = null;
      if (document.caretRangeFromPoint) {
        range = document.caretRangeFromPoint(x, y);
      } else if (document.caretPositionFromPoint) {
        const pos = document.caretPositionFromPoint(x, y);
        if (pos) {
          range = document.createRange();
          range.setStart(pos.offsetNode, pos.offset);
          range.collapse(true);
        }
      }
      if (range) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        return true;
      }
      return false;
    }

    // \u5224\u65AD\u8282\u70B9\u662F\u5426\u5728\u67D0\u4E2A tag \u5185\u90E8
    function getParentTag(node) {
      while (node && node !== editor) {
        if (node.nodeType === Node.ELEMENT_NODE && node.classList && node.classList.contains('tag')) return node;
        node = node.parentNode;
      }
      return null;
    }

    // ========== \u9009\u62E9\u6A21\u5F0F\u7BA1\u7406 ==========
    // \u62D6\u9009\u65F6\u4E34\u65F6\u8BA9 tag \u8DDF\u968F editor \u53EF\u7F16\u8F91\uFF0C\u5426\u5219 Android WebView \u4F1A\u5728\u78B0\u5230
    // contentEditable=false \u7684\u5143\u7D20\u65F6\u622A\u65AD\u9009\u533A\u3002\u9009\u533A\u6536\u8D77\u540E\u518D\u6062\u590D\u4E0D\u53EF\u7F16\u8F91\u72B6\u6001\u3002
    let _isSelectionMode = false;
    let _selectionExitTimer = null;

    function enterSelectionMode() {
      if (_isSelectionMode) return;
      _isSelectionMode = true;
      const tags = editor.querySelectorAll('.tag');
      for (let i = 0; i < tags.length; i++) {
        tags[i].contentEditable = 'inherit';
      }
    }

    function exitSelectionMode() {
      if (!_isSelectionMode) return;
      _isSelectionMode = false;
      const tags = editor.querySelectorAll('.tag');
      for (let i = 0; i < tags.length; i++) {
        tags[i].contentEditable = 'false';
      }
    }

    document.addEventListener('selectionchange', () => {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;
      const range = sel.getRangeAt(0);
      if (!editor.contains(range.startContainer) || !editor.contains(range.endContainer)) return;
      if (range.collapsed) {
        saveCaretSnapshot(range);
      }

      if (!range.collapsed) {
        enterSelectionMode();
        if (_selectionExitTimer) {
          clearTimeout(_selectionExitTimer);
          _selectionExitTimer = null;
        }
        return;
      }

      if (_isSelectionMode) {
        // collapsed \u72B6\u6001\u53EF\u80FD\u53EA\u662F\u62D6\u9009\u8FC7\u7A0B\u4E2D\u7684\u77AC\u65F6\u72B6\u6001\uFF0C\u5EF6\u8FDF\u9000\u51FA\u907F\u514D\u6253\u65AD\u62D6\u9009\u3002
        // Android \u5EF6\u8FDF\u66F4\u77ED\uFF0C\u51CF\u5C11 contentEditable \u5207\u6362\u5BF9\u666E\u901A\u5149\u6807\u663E\u793A\u7684\u5F71\u54CD\u3002
        if (_selectionExitTimer) clearTimeout(_selectionExitTimer);
        _selectionExitTimer = setTimeout(() => {
          _selectionExitTimer = null;
          const currentSel = window.getSelection();
          if (currentSel && currentSel.rangeCount > 0 && !currentSel.getRangeAt(0).collapsed) return;
          exitSelectionMode();
        }, isAndroid ? 80 : 200);
      }

      if (isAndroid) {
        if (!range.collapsed) return;
      }

      if (isAndroid && range.startContainer.nodeType === Node.TEXT_NODE) {
        const spacerNode = range.startContainer;
        const spacerText = spacerNode.textContent || '';
        const prevTag = isTagElement(spacerNode.previousSibling) ? spacerNode.previousSibling : null;
        const nextTag = isTagElement(spacerNode.nextSibling) ? spacerNode.nextSibling : null;
        if (hasOnlyGeneratedTagAnchors(spacerText) && (prevTag || nextTag)) {
          if (prevTag && nextTag) {
            if (range.startOffset <= 0) {
              placeCaretAfterTag(prevTag, false, false);
            } else {
              placeCaretBeforeTag(nextTag, false);
            }
          } else if (prevTag) {
            placeCaretAfterTag(prevTag, false, false);
          } else if (nextTag) {
            placeCaretBeforeTag(nextTag, false);
          }
          return;
        }
      }

      // \u5149\u6807\u843D\u5728 tag \u5185\u90E8\u65F6\uFF0C\u5F39\u5230 tag \u5916\u9762\uFF08\u4EC5\u975E\u9009\u62E9\u6A21\u5F0F\u4E0B\u5904\u7406\uFF09
      if (_isSelectionMode) return;
      const tagEl = getParentTag(range.startContainer);
      if (!tagEl) return;

      // \u5224\u65AD\u5149\u6807\u5728 tag \u7684\u524D\u534A\u90E8\u5206\u8FD8\u662F\u540E\u534A\u90E8\u5206
      const container = range.startContainer;
      const offset = range.startOffset;
      let moveBefore = true;
      if (container === tagEl) {
        moveBefore = offset <= Math.floor(tagEl.childNodes.length / 2);
      } else if (container.nodeType === Node.TEXT_NODE) {
        const textLen = container.textContent.length;
        moveBefore = offset <= Math.floor(textLen / 2);
      }

      if (moveBefore) {
        placeCaretBeforeTag(tagEl, false);
      } else {
        placeCaretAfterTag(tagEl, false, false);
      }
    });

    // \u963B\u6B62\u5728 tag \u5185\u90E8\u8F93\u5165\u5185\u5BB9
    editor.addEventListener('beforeinput', (e) => {
      if (e.inputType && e.inputType.startsWith('delete')) {
        if (suppressNextDeleteBeforeInput) {
          suppressNextDeleteBeforeInput = false;
          e.preventDefault();
          return;
        }
        const direction = e.inputType.indexOf('Forward') > -1 ? 'forward' : 'backward';
        if (handleTagDeletion(direction)) {
          e.preventDefault();
          return;
        }
      }

      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;
      const range = sel.getRangeAt(0);
      if (getParentTag(range.startContainer) || getParentTag(range.endContainer)) {
        // \u5141\u8BB8\u5220\u9664\u64CD\u4F5C\uFF08\u7531 keydown \u5904\u7406\uFF09\uFF0C\u963B\u6B62\u5176\u4ED6\u8F93\u5165
        if (e.inputType && !e.inputType.startsWith('delete')) {
          e.preventDefault();
        }
      }
    });

    // \u76D1\u542C touchend \u624B\u52A8\u5B9A\u4F4D\u5149\u6807\uFF08\u4EC5\u5728\u7279\u6B8A\u573A\u666F\u5982\u6807\u7B7E\u5468\u56F4\u624D\u5F3A\u5E72\u9884\uFF0C\u907F\u514D\u7834\u574F\u539F\u751F\u53CC\u51FB\u548C\u9009\u533A\uFF09
    let _touchMoved = false;
    editor.addEventListener('touchstart', () => { _touchMoved = false; }, { passive: true });
    editor.addEventListener('touchmove', () => { _touchMoved = true; }, { passive: true });
    editor.addEventListener('touchend', (e) => {
      if (_touchMoved) return;
      // \u70B9\u51FB\u7F16\u8F91\u6846\u5185\u5176\u4ED6\u4F4D\u7F6E\u65F6\u5173\u95ED\u5F39\u7A97
      if (currentTriggerChar) {
        hideMentionPopup();
      }

      // \u5982\u679C\u5F53\u524D\u5B58\u5728\u975E\u95ED\u5408\u9009\u533A\uFF08\u5373\u6B63\u5728\u62D6\u62FD\u9009\u4E2D\u6587\u5B57\uFF09\uFF0C\u4E0D\u5E72\u9884\u5149\u6807\uFF0C\u907F\u514D\u9009\u533A\u6D88\u5931
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0 && !sel.getRangeAt(0).collapsed) return;

      // \u4E0D\u518D\u5168\u5C40\u5F3A\u5236 setCaretFromPoint\uFF0C\u53EA\u5728\u70B9\u51FB\u6807\u7B7E\u5143\u7D20\u65F6\u624D\u4ECB\u5165
      const shouldForceCaretFromPoint =
        !!(e.target && getParentTag(e.target)) || Date.now() - lastEditorBlurAt < 1200;
      if (shouldForceCaretFromPoint) {
        if (e.changedTouches && e.changedTouches.length > 0) {
          const touch = e.changedTouches[0];
          setTimeout(() => {
            const currentSel = window.getSelection();
            if (currentSel && currentSel.rangeCount > 0 && !currentSel.getRangeAt(0).collapsed) return;
            setCaretFromPoint(touch.clientX, touch.clientY);
          }, 0);
        }
      }
    }, { passive: true });

    // \u684C\u9762\u7AEF click \u4E5F\u5904\u7406
    editor.addEventListener('click', (e) => {
      // \u70B9\u51FB\u7F16\u8F91\u6846\u5185\u5176\u4ED6\u4F4D\u7F6E\u65F6\u5173\u95ED\u5F39\u7A97
      if (currentTriggerChar) {
        hideMentionPopup();
      }

      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0 && !sel.getRangeAt(0).collapsed) return;

      // \u540C\u4E0A\uFF0C\u4E0D\u518D\u5168\u5C40\u5F3A\u5236 setCaretFromPoint
      const shouldForceCaretFromPoint =
        !!(e.target && getParentTag(e.target)) || Date.now() - lastEditorBlurAt < 1200;
      if (shouldForceCaretFromPoint) {
        setCaretFromPoint(e.clientX, e.clientY);
      }
    });

    // \u53CC\u51FB\u9009\u4E2D\u6807\u7B7E\u5143\u7D20
    editor.addEventListener('dblclick', (e) => {
      const tagEl = e.target.closest('.tag');
      if (tagEl) {
        e.preventDefault();
        const sel = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(tagEl);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    });

    applyPlatformBehavior();
    postMessage({ type: 'ready' });
  <\/script>
</body>
</html>
`;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/yofoui/customized/richedit/editor.ts